import { validation_status  } from '@app/config/validation-status.enum';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'validationInfoMessage'
})
export class ValidationInfoMessagePipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {

    switch (value) {
      case validation_status.none: return '';
      case validation_status.success: return 'Completo';
      case validation_status.warning: return '¡Puede mejorar!';
      case validation_status.error: return 'Incompleto';
    }
    return null;
  }

}
